import React, { useState } from 'react';

import { images } from '../../constants';
import { Popup } from '../../components';

import { BsInstagram, BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';

import './Gallery.css';

import { data } from '../../constants';

const Gallery = () => {

  const scrollRef = React.useRef(null)

  const scroll = (direction) => {
    const { current } = scrollRef;

    if (direction === 'left') {
      current.scrollLeft -= 300;
    }
    else {
      current.scrollLeft += 300;
    }
  }


  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const openPopup = (project) => {
    setIsPopupOpen(true);
    setSelectedProject(project);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedProject(null);
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className='app__gallery flex__center' style={{ padding: '10rem 4rem' }} id='projects'>
      <div className='app__gallery-content'>
        <h1 className='headtext__cormorant'>Projects</h1>

        <a href="https://github.com/sharadTT" target="_blank" rel="noopener noreferrer">
          <button type="button" className='custom__button'>View On Github</button>
        </a>
      </div>

      <div className='app__gallery-images'>
        <div className='app__gallery-images_container' ref={scrollRef}>

          {data.projects.map((project, index) => (
            <div className='app__gallery-images_container-inner'>
              <div key={index}>
                <h1 className='app__gallery-projectTitle'>{project.title}</h1>
                <div className='app__gallery-images_card flex__center'>
                  <img
                    src={project.img}
                    alt="gallery"
                    

                  />
                  <div className= "app__gallery-project_description" onClick={() => { window.open(project.link, '_blank'); }}>
                    {project.description}
                  </div>
                  
                </div>
                <div className="app__gallery-project_tags">
                  {project.tags.map((point, index) => (
                    <p key={`project-tag-${index}`}>{point}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}

          {isPopupOpen && selectedProject && (
            <Popup project={selectedProject} onClose={closePopup} />
          )}

        </div>
        <div className='app__gallery-images_arrows'>
          <BsArrowLeftShort className='gallery__arrows-icon' onClick={() => scroll('left')} />
          <BsArrowRightShort className='gallery__arrows-icon' onClick={() => scroll('right')} />
        </div>
      </div>
    </div>
  )
}

export default Gallery;
